import { FormContainer } from "@/components/form/FormContainer";
import { useResourceUpdate } from "@/hooks";
import { useOne } from "@refinedev/core";
import { useResourceNavigate } from "@/hooks/useResourceNavigate";
import { UpdateWrapper } from "@/layouts/UpdateWrapper";
import { RESOURCE_TYPE_ADDON, RESOURCE_TYPE_USERS } from "@/resources-def";
import { Button, Space } from "antd";
import { useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { getAddonVersionSchema } from "@/resources-def/addons-comp";

const RESOURCE = RESOURCE_TYPE_ADDON;

export const AddonVersionEditor = ({id, version}) => {
  const formRef = useRef();
  const navigate = useResourceNavigate();
  const navigateBack = useNavigate();
  const { data, isLoading, isError } = useOne({
    resource: RESOURCE, 
    id: id,
    meta: { version: version },
  });
  const { mutateAsync, isLoading: isSaving } = useResourceUpdate({resource: RESOURCE});

  const rawSchema = getAddonVersionSchema(data?.type, true, true);

  const doCommit = async (values) => {
    await formRef.current?.validateFields();
    if(values.tableData) {
      values.requires = JSON.stringify(Object.values(values.tableData));
      delete values.tableData;
    }
    values.name = data.name;
    const result = await mutateAsync({ version: version, data: values });
    if (result.status === "OK") {
      if (window.history.length > 1) {
        navigateBack(-1);
      } else {
        navigate({ resource: "setting/" + RESOURCE, action: "list" });
      }
    } else {
      // TODO: show error message
    }
  };

  return (
    <UpdateWrapper
      footer={
        <Space>
          <Button
            onClick={() => {
              if (window.history.length > 1) {
                navigateBack(-1);
              } else {
                navigate({ resource: "setting/" + RESOURCE, action: "list" });
              }
            }}
          >
            Cancel
          </Button>
          <Button loading={isSaving} type="primary" onClick={() => formRef.current.submit()}>
            Save
          </Button>
        </Space>
      }
    >
      {isLoading && <div>Loading...</div>}
      {!isLoading && (
        <FormContainer
          formRef={formRef}
          initValue={data}
          schema={rawSchema}
          onFinishCallback={doCommit}
          style={{ paddingTop: 24 }}
          formItemLayout={{
            labelCol: { span: 6 },
            wrapperCol: { span: 18 },
          }}
        />
      )}
    </UpdateWrapper>
  );
};
